<div *ngIf="driver" class="driver-details-tabs">

  <div class="tabs">
    <div class="eco-tab" (click)="tab = 'data'" [ngClass]="{'selected': tab === 'data' }">
      {{ 'labels.data' | translate }}
    </div>
<!--    <div class="eco-tab" (click)="tab = 'eco'" [ngClass]="{'selected': tab === 'eco' }">Eco</div>-->
<!--    <div class="tacho-tab" (click)="tab = 'tacho'" [ngClass]="{'selected': tab === 'tacho' }">Tacho</div>-->
  </div>

  <div class="line"></div>

  <wm-driver-details-data-tab *ngIf="tab === 'data'" class="content" [driver]="driver"></wm-driver-details-data-tab>
<!--  <tk-driver-details-eco-tab *ngIf="tab === 'eco'" class="content" [driver]="driver"></tk-driver-details-eco-tab>-->
<!--  <tk-driver-details-tacho-tab *ngIf="tab === 'tacho'" class="content" [driver]="driver"></tk-driver-details-tacho-tab>-->

</div>
